
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Cliente } from '@/__env/lib/Clientes';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        @Prop() public Item: Cliente;
        @Prop() public Items: Cliente[];
        @Prop() public Index: number;
        @Prop() public Busqueda: string;


        public Resaltar( x: string )
        {
            return x.toUpperCase().replace( this.Busqueda.toUpperCase(), `<b>${this.Busqueda.toUpperCase()}</b>` );
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {


        }

    }
